import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { useSuperAdminUsers } from "../../../context/SuperAdmin/UsersContext";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import RowUser from "../Organization/Users/RowUser";

const UsersTable = () => {
  const { filteredUsers, assignToDeleteUser, handleEdit } =
    useSuperAdminUsers();
  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
        mt: 2,
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }}>
        <TableHead sx={{ height: 20, width: "100%" }}>
          <TableRow>
            <StyledTableCell>N°</StyledTableCell>
            <StyledTableCell>Nombre</StyledTableCell>
            <StyledTableCell>Apellido</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            <StyledTableCell align="center">Fecha de creación</StyledTableCell>
            <StyledTableCell>Estado</StyledTableCell>
            <StyledTableCell align="center">Acciones</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredUsers.length > 0 ? (
            filteredUsers.map((user, index) => (
              <RowUser
                key={user.id_usuario}
                usuario={user}
                index={index + 1}
                assignToDeleteUser={assignToDeleteUser}
                handleEdit={handleEdit}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UsersTable;
